/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { AxiosContext } from '../contexts/AxiosContext';
import { getRequest } from '../contexts/AxiosRequests';
import { notification } from 'antd';
import { useRecoilValue } from 'recoil';
import appAtom from '../atoms/auth/app.atom';

interface GetActionProps<T> {
  url: string;
  params?: Record<string, any>;
  keys?: string[];
  funcKey: string;
  successAction?: (response: T) => void;
}

interface ErrorResponse {
  message?: string;
  errors?: Record<string, string[]>;
}

export default function useGetAction<T = any>({
  url,
  params,
  funcKey,
  successAction,
  enabled = true,
}: GetActionProps<T> & { enabled?: boolean }) {
  const axios = useContext(AxiosContext);
  const { company_id, estate_id } = useRecoilValue(appAtom);

  if (!axios) {
    throw new Error(
      'Axios context not found. Did you forget to wrap in <AxiosProvider>?'
    );
  }

  return useQuery<T, ErrorResponse>(
    [funcKey, JSON.stringify(params), company_id, estate_id],
    () => getRequest(axios, url, {...params, per_page: params?.per_page || 10000}),
    {
      enabled,
      onSuccess: (response) => successAction?.(response),
      onError: (error) =>
        notification.error({
          message: 'Error!',
          description: error?.message
            ? Object.entries(error?.errors || { key: [error.message] })
              .map(([, value]) => value.join(', '))
              .join(', ')
            : 'Something went wrong. Please check your internet connection.',
        }),
      retry: 2,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 10,
      cacheTime: 1000 * 10,
    }
  );
}
